module.exports = __webpack_public_path__ + "static/newJoin-2-63a963d7b456eaab38fcfe0c6ba17d1e.png";